/* =========================================================
   VFW Product Nav (2026-09-17)
   · Drops links whose target section is missing or empty.
   · Orders the rail by document position (left→right = top→bottom).
   · Sticks under the fixed site header once scrolled past (CSS sticky);
     --vfw-pnav-top is a data channel carrying the header's bottom edge.
   · aria-current="location" on the section in view; the mobile rail
     scrolls the active link into view horizontally only.
   · Anchor targets get scroll-margin so headings clear header + bar.
   ========================================================= */
(() => {
  const nav = document.querySelector('[data-pnav]');
  if (!nav) return;
  const rail = nav.querySelector('[data-pnav-rail]');
  const section = nav.closest('.shopify-section');
  const header = document.querySelector('.vfw-header');

  const items = Array.from(rail.querySelectorAll('[data-pnav-key]'))
    .map((a) => {
      const target = document.getElementById(a.getAttribute('href').slice(1));
      return { a, li: a.parentElement, target };
    })
    .filter((it) => {
      const ok = it.target && it.target.getBoundingClientRect().height > 8;
      if (!ok) it.li.remove();
      return ok;
    })
    .sort((x, y) => (x.target.compareDocumentPosition(y.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
  items.forEach((it) => rail.appendChild(it.li));
  if (!items.length) { if (section) section.hidden = true; return; }

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let headerH = 0;

  const measure = () => {
    headerH = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    nav.style.setProperty('--vfw-pnav-top', `${headerH}px`);
    if (section) section.style.setProperty('--vfw-pnav-h', `${nav.offsetHeight}px`);
    const offset = headerH + nav.offsetHeight + 12;
    items.forEach((it) => it.target.style.setProperty('scroll-margin-top', `${offset}px`));
  };

  const setActive = () => {
    const line = headerH + nav.offsetHeight + 24;
    let current = null;
    items.forEach((it) => { if (it.target.getBoundingClientRect().top <= line) current = it; });
    // Pin once the bar's own slot has scrolled up under the header.
    const slotTop = section ? section.getBoundingClientRect().top : nav.getBoundingClientRect().top;
    // Release once the last linked section has scrolled away (related
    // products and the footer are not part of this navigation).
    const lastBottom = items[items.length - 1].target.getBoundingClientRect().bottom;
    const pinned = slotTop <= headerH && lastBottom > headerH + nav.offsetHeight;
    nav.classList.toggle('is-pinned', pinned);
    items.forEach((it) => {
      const on = it === current;
      if (on) it.a.setAttribute('aria-current', 'location'); else it.a.removeAttribute('aria-current');
      it.a.classList.toggle('is-active', on);
      if (on && rail.scrollWidth > rail.clientWidth) {
        const l = it.li.offsetLeft - (rail.clientWidth - it.li.offsetWidth) / 2;
        rail.scrollTo({ left: Math.max(0, l), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; measure(); setActive(); });
  };

  nav.querySelector('[data-pnav-top]').addEventListener('click', (e) => {
    e.preventDefault();
    const behavior = reduce.matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
    const pw = document.querySelector('.page-wrapper');
    if (pw) pw.scrollTo({ top: 0, behavior });
  });

  /* Add to Cart is always in the rail (James, 2026-09-18) — it no longer waits
     for the bar to pin. Clicks go to the main product form, so variant,
     quantity and state live in one place. */
  const atc = nav.querySelector('[data-pnav-atc]');
  const mainAtc = document.getElementById('vfw-atc-btn');
  const form = document.querySelector('.vfw-product-form');
  if (atc && mainAtc && form) {
    atc.addEventListener('click', () => {
      if (form.requestSubmit) form.requestSubmit(mainAtc); else mainAtc.click();
    });
    /* The button belongs to the pinned state, not to a second observer:
       tying it to the main button's position made it pop in part-way down the
       page, out of step with the bar itself (James, 2026-09-18). */
  }

  measure(); setActive();
  window.addEventListener('scroll', onScroll, { passive: true });
  const pw = document.querySelector('.page-wrapper');
  if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
